import { auth0ApiClient } from './auth0ApiClient'
import { RelationshipStatus } from '@/types/matching'

export interface AdminRelationshipParty {
  id: string
  firstName: string
  lastName: string
  email: string
}

export interface AdminRelationship {
  id: string
  mentorId: string
  menteeId: string
  mentor: AdminRelationshipParty
  mentee: AdminRelationshipParty
  status: RelationshipStatus
  requestedAt: string
  acceptedAt?: string
  completedAt?: string
  notes?: string
}

export interface AdminRelationshipListFilters {
  mentorId?: string
  menteeId?: string
  status?: RelationshipStatus
  page?: number
  limit?: number
}

export interface AdminRelationshipListPagination {
  page: number
  limit: number
  totalDocs: number
  totalPages: number
  hasNextPage: boolean
  hasPrevPage: boolean
}

export interface AdminRelationshipListResponse {
  relationships: AdminRelationship[]
  pagination: AdminRelationshipListPagination
}

interface AdminRelationshipListEnvelope {
  success: boolean
  data: AdminRelationshipListResponse
}

class AdminRelationshipService {
  private readonly baseUrl = '/matching/admin/relationships'

  async listRelationships(filters: AdminRelationshipListFilters = {}): Promise<AdminRelationshipListResponse> {
    const envelope = await auth0ApiClient.getEnvelope<AdminRelationshipListEnvelope>(this.baseUrl, {
      params: {
        mentorId: filters.mentorId || undefined,
        menteeId: filters.menteeId || undefined,
        status: filters.status || undefined,
        page: filters.page,
        limit: filters.limit
      }
    })
    return envelope.data
  }

  async forceEndRelationship(id: string, reason: string): Promise<{ id: string; status: RelationshipStatus; cancelledAt?: string }> {
    return auth0ApiClient.post(`${this.baseUrl}/${id}/force-end`, { reason })
  }
}

export const adminRelationshipService = new AdminRelationshipService()
